/**
 * @generated SignedSource<<1270ecd8f0073960994b4cba0e925b73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VoteRowTextFragment$data = {
  readonly supportDetailed: number;
  readonly " $fragmentType": "VoteRowTextFragment";
};
export type VoteRowTextFragment$key = {
  readonly " $data"?: VoteRowTextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VoteRowTextFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VoteRowTextFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportDetailed",
      "storageKey": null
    }
  ],
  "type": "Vote",
  "abstractKey": null
};

(node as any).hash = "10328c6902d1518601d6e7fc93f72adc";

export default node;
